import React from 'react';
import './AddToCartModal.css';
import ProductCard from './ProductCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTimes } from '@fortawesome/free-solid-svg-icons';

const AddToCartModal = ({ 
    product, 
    recommendedProducts, 
    onClose, 
    onGoToCart, 
    onContinueShopping,
    isFavorite,
    onFavoriteToggle 
}) => {
    if (!product) return null;

    return (
        <div className="add-to-cart-modal-overlay">
            <div className="add-to-cart-modal-content">
                <button className="close-button" onClick={onClose}>
                    <FontAwesomeIcon icon={faTimes} />
                </button>

                <div className="modal-header d-flex flex-column align-items-center">
                    <h2>Ürün başarıyla sepete eklendi!</h2>
                    <FontAwesomeIcon icon={faCheckCircle} className="success-icon" />
                </div>

                <div className="added-product-summary">
                    <img src={product.image} alt={product.name} />
                    <div className="product-info">
                        <h3>{product.name}</h3>
                        <p className="price">{product.price.toLocaleString('tr-TR')} TL</p>
                    </div>
                </div>

                <div className="modal-actions">
                    <button className="btn-primary" onClick={onContinueShopping}>Alışverişe Devam Et</button>
                    <button className="btn-primary" onClick={onGoToCart}>Sepete Git</button>
                </div>

                <div className="recommended-products-section">
                    <h4>Bu Ürünlerle Tamamlayın</h4>
                    <div className="recommended-products-list">
                        {recommendedProducts.map(recProduct => (
                            <ProductCard
                                key={recProduct.id}
                                product={recProduct}
                                isFavorite={isFavorite}
                                onFavoriteToggle={onFavoriteToggle}
                                showGramPrice={false} // Modal içinde gram fiyatını göstermeyebiliriz
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddToCartModal;
